var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    d: "M-3 0h60v10H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M-3 30h60v10H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    d: "M-3 20h60v10H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-3 10h60v10H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M22 0h10v40H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M9.6 8.8 7 7 4.4 8.8l1-3-2.6-2H6l1-3 1 3h3.2l-2.5 2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.2a594862958084fbb91b9246a8948067.svg";
export { ForwardRef as ReactComponent };